/** ***************
 ***** Roles *****
 **************** */

enum SystemRolesIds {
  Admin = "SystemAdmin",
}

enum UserRoleIds {
  Read = "UserStandardSystemRole",
  Write = "UserAsSelf",
}

export enum WorkspaceRoleIds {
  Read = "WorkspaceViewOnly",
  Write = "WorkspaceAdmin",
}

export enum OrgRoleIds {
  Admin = "OrganizationAdmin",
  Maintainer = "OrganizationMaintainer",
  Member = "OrganizationMember",
  Owner = "OrganizationOwner",
  ViewOnly = "OrganizationViewOnly",
}

export type RoleIds =
  | SystemRolesIds
  | UserRoleIds
  | WorkspaceRoleIds
  | OrgRoleIds;

/** *****************
 ***** Actions *****
 ****************** */

enum TopLevelActions {
  CreateOrganizations = "CreateOrganizations",
  CreateUsers = "CreateUsers",
  ViewRoles = "ViewRoles",
}

enum OrganizationActions {
  ViewOrganization = "ViewOrganization",
  ModifyOrganization = "ModifyOrganization",
  DeleteOrganization = "DeleteOrganization",
  ViewOrganizationPermissions = "ViewOrganizationPermissions",
  ModifyOrganizationPermission = "ModifyOrganizationPermission",
  DeleteOrganizationPermission = "DeleteOrganizationPermission",
  ViewOrganizationRoleAttachments = "ViewOrganizationRoleAttachments",
  ModifyOrganizationRoleAttachments = "ModifyOrganizationRoleAttachments",
  DeleteOrganizationRoleAttachments = "DeleteOrganizationRoleAttachments",
  CreateWorkspaces = "CreateWorkspaces",
  ViewWorkspaces = "ViewWorkspaces",
}

enum UserActions {
  ViewUser = "ViewUser",
  TestUserPermissions = "TestUserPermissions",
  ModifyUser = "ModifyUser",
  DeleteUser = "DeleteUser",
}

enum WorkspaceActions {
  ViewWorkspace = "ViewWorkspace",
  ModifyWorkspace = "ModifyWorkspace",
  DeleteWorkspace = "DeleteWorkspace",
  ViewWorkspacePermissions = "ViewWorkspacePermissions",
  ModifyWorkspacePermission = "ModifyWorkspacePermission",
  DeleteWorkspacePermission = "DeleteWorkspacePermission",
  ViewWorkspaceRoleAttachments = "ViewWorkspaceRoleAttachments",
  ModifyWorkspaceRoleAttachments = "ModifyWorkspaceRoleAttachments",
  DeleteWorkspaceRoleAttachment = "DeleteWorkspaceRoleAttachment",
  StopWorkspace = "StopWorkspace",
  StartWorkspace = "StartWorkspace",
  ResetWorkspace = "ResetWorkspace",
}

enum WorkspaceGroupActions {
  ViewWorkspaceGroup = "ViewWorkspaceGroup",
}

enum WorkspaceTemplateActions {
  ViewWorkspaceTemplate = "ViewWorkspaceTemplate",
}

export type Actions =
  | TopLevelActions
  | OrganizationActions
  | UserActions
  | WorkspaceActions
  | WorkspaceGroupActions
  | WorkspaceTemplateActions;

export default interface IRole {
  actions: Array<Actions>;
  id: RoleIds;
}
